import { useState } from "react";
import { Gift, Mail, ArrowRight, Check, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/context/LanguageContext";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CompactCommunityBanner = ({ onReferralClick }) => {
  const { language } = useLanguage();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) return;

    setStatus("loading");
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, {
        email: email.trim().toLowerCase(),
      });
      if (response.data.success) {
        setStatus("success");
        setEmail("");
        setTimeout(() => setStatus("idle"), 3000);
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section className="py-8 bg-gradient-to-r from-zinc-900 via-zinc-800 to-zinc-900 border-y border-zinc-700/50" data-testid="compact-community-banner">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Referral CTA */}
          <button
            onClick={onReferralClick}
            className="group flex items-center gap-3 bg-gradient-to-r from-amber-500/10 to-amber-600/10 hover:from-amber-500/20 hover:to-amber-600/20 border border-amber-500/30 rounded-full px-5 py-3 transition-all"
            data-testid="banner-referral-btn"
          >
            <div className="p-2 bg-amber-500/20 rounded-full">
              <Gift className="w-4 h-4 text-amber-400" />
            </div>
            <span className="text-white text-sm">
              {language === "fr" ? "Référez un ami" : "Refer a Friend"}
            </span>
            <span className="text-amber-400 font-semibold">
              {language === "fr" ? "Obtenez 50$ chacun" : "Get $50 Each"}
            </span>
            <ArrowRight className="w-4 h-4 text-amber-400 group-hover:translate-x-1 transition-transform" />
          </button>

          {/* Newsletter Signup */}
          <form onSubmit={handleSubmit} className="flex items-center gap-2">
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <Sparkles className="w-4 h-4 text-amber-400" />
              <span className="hidden sm:inline">
                {language === "fr" ? "Offres VIP:" : "VIP Offers:"}
              </span>
            </div>
            
            {status === "success" ? (
              <div className="flex items-center gap-2 text-green-400 text-sm px-4 py-2 bg-green-500/10 rounded-full">
                <Check className="w-4 h-4" />
                {language === "fr" ? "Bienvenue!" : "You're in!"}
              </div>
            ) : (
              <>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={language === "fr" ? "votre@courriel.com" : "your@email.com"}
                  className="w-48 sm:w-56 bg-zinc-800 border-zinc-700 text-white text-sm h-10 rounded-full"
                  data-testid="banner-newsletter-email"
                />
                <Button
                  type="submit"
                  disabled={status === "loading"}
                  className="bg-white hover:bg-zinc-200 text-black text-sm h-10 px-4 rounded-full"
                  data-testid="banner-newsletter-submit"
                >
                  {status === "loading" ? (
                    <div className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin" />
                  ) : (
                    <Mail className="w-4 h-4" />
                  )}
                </Button>
              </>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default CompactCommunityBanner;
